import React, { createContext, useContext } from "react";

export const DashboardChromeContext = createContext({
  accountSwitcher: null,
  searchEnabled: false,
  openSearchPalette: () => {},
  openUserMenu: () => {},
});

export const DashboardChromeProvider = ({ value, children }) => (
  <DashboardChromeContext.Provider value={value}>
    {children}
  </DashboardChromeContext.Provider>
);

export const useDashboardChrome = () => useContext(DashboardChromeContext);
